type PageLoadingStateProps = {
  text?: string;
};

const PageLoadingState = ({ text = '加载中...' }: PageLoadingStateProps) => (
  <div className="page-state page-state-loading">
    <div className="page-state-spinner" />
    <div className="page-state-text">{text}</div>
  </div>
);

export default PageLoadingState;
